import React from "react";
import Cart from "@system/config/cart";
import noImage from 'src/assets/images/noimage.png'
import System from 'src/helper/system';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import DisplayLongDescriptionAndVariantMFRName from 'src/component/custom/DisplayLongDescriptionAndVariantMFRName';
import { useCartStore } from "src/hooks/cart";
import { useSystem } from "src/hooks/system";

const AddedToCartBomPopup = (props) => {
    const { data: { cartData }, SetStatus } = props
    const [{ CART_DATA }, { }, { }] = useCartStore()
    const { translation: t } = System;
    const [, { get_quantity_format }] = useSystem();

    const onHide = (action = true) => {
        SetStatus(false)
    };
    const getSubTotal = () => {
        let subtotal = 0;
        if (cartData.length > 0) {
            cartData.map((v) => {
                subtotal = subtotal + CART_DATA[v.itemNumber].subtotal
            })
            console.log(subtotal)
            return System.getFormatNumber({ amount: Number(subtotal), maximumFractionDigits: 2, isDisplaySymbol: false, currency: System.getRegionCurrency() })
        }
    }
    return (
        <>
            <div>
                {(cartData && cartData.length > 0) &&
                    <div className="avnet-modal modal-680 bomaddcart">
                        <div className="avnet-modal-inner">
                            {/* Modal Header */}
                            <button type="button" className="close py-3" data-dismiss="modal"
                                onClick={() => { onHide() }}
                            >×</button>
                            <div className="modal-header justify-content-center mt-0">
                                <h3 className="pcn-modal-heading pl-5">({cartData.length}){t('itemsAddedToYourCart')}</h3>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body overflow-hidden">
                                <div className="clearfix" />
                                <div className="add-to-cart-list ordercartlist">
                                    {cartData.map((v, i) => (
                                        <div key={i} className="add-to-cart-item">
                                            <div className="bs5 row m-0">
                                                <div className="col-auto p-0">
                                                    <div className="add-to-cart-item-img">
                                                        <img className="img-fluid" src={v.assetURL && v.assetURL.trim() !== '' ? v.assetURL : noImage} />
                                                    </div>
                                                </div>
                                                <div className="col-auto p-0">
                                                    <div className="add-to-cart-item-info">
                                                        <NavigateToProductDetail data={{ ManufacturerName: v.manufacturerName, ERPMFRPartNumber: v.erpMfrPartNumber, ItemNumber: v.itemNumber, ERPPartNumber: v.ERPPartNumber, seoItemNumber: v.seoItemNumber }}>
                                                            {v.erpMfrPartNumber}
                                                        </NavigateToProductDetail>
                                                        <DisplayLongDescriptionAndVariantMFRName
                                                            currentProduct={{ ManufacturerName: v?.manufacturerName, ShortDescription: v?.ShortDescription }} />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-auto mt-3 mt-sm-0 ms-auto p-0">
                                                    <div className="add-to-cart-price">
                                                        <div className="add-to-cart-price-item">
                                                            <span>{t('unitPrice')}:</span>
                                                            <b>{System.getFormatNumber({ amount: Number(CART_DATA[v.itemNumber].unitPrice), currency: System.getRegionCurrency() })} </b>
                                                        </div>
                                                        <div className="add-to-cart-price-item">
                                                            <span>{t('quantity')}:</span>
                                                            <b>{get_quantity_format(v.quantity)}</b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                                <div className="text-end mt-2 font-12 cart-subtotal">
                                    <span> {t('itemSubTotal')} ({System.getRegionCurrency()}): <b>{getSubTotal()}</b></span>
                                </div>
                            </div>
                            {/* Modal footer */}
                            <div className="modal-footer text-center">
                                <div className="modal-footer-actions">
                                    <button onClick={onHide}
                                        type="button" className="bs5 btn btn-secondary btn-sm text-uppercase"
                                        data-dismiss="modal">
                                        {t('continueShopping')}
                                    </button>
                                    <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                        onClick={() => { window.location.href = Cart.getCartPageRouteURL() }}
                                        data-dismiss="modal">
                                        {t('viewCart')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    );
}

export default AddedToCartBomPopup;